import { render, staticRenderFns } from "./StandappOtpComponent.vue?vue&type=template&id=a641b9bc&"
import script from "./StandappOtpComponent.vue?vue&type=script&lang=js&"
export * from "./StandappOtpComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports